import React from 'react'
import Heading from '../../Components/Heading/Heading';
import ViewTypeTable from '../../Components/ViewTypeTable/ViewTypeTable';
import styles from "./settings.module.css"
import PaymentMethodTable from '../../Components/PaymentMethodTable/PaymentMethodTable';
import WorkTimeTable from '../../Components/WorkTimeTable/WorkTimeTable';
import DiscountReasonTable from '../../Components/DiscountReason/DiscountReason';
function Settings() {
  return (
    <div>
      <Heading title="الإعدادات" />
      <div className={styles.container}>
        <div className={styles.row}>
          <DiscountReasonTable />
          <WorkTimeTable />
        </div>
        <ViewTypeTable />
        <PaymentMethodTable />
      </div>
    </div>
  );
}

export default Settings